module.exports = __webpack_public_path__ + "img/dtSmall.a87bc1c5.png";